import { CampaignStatus, CreateCampaignInput } from 'generated-graphql/types';
import { mapQuestionOrder } from './mapQuestionOrder';
import { CampaignToDuplicate } from 'modules/campaigns/types/CampaignToDuplicate';
import { sanitizeObject } from 'utils/fomatting';

export const mapToDuplicateCampaignInput = (
  userId: string,
  organizationId: string,
  status: CampaignStatus,
  campaign: CampaignToDuplicate
): CreateCampaignInput => {
  return sanitizeObject<CreateCampaignInput>({
    agentId: campaign.agentId,
    userId,
    organizationId,
    status,
    type: campaign.type,
    title: `${campaign.title} (copy)`,
    questions: mapQuestionOrder(campaign.questions),
    meetingUrl: campaign.meetingUrl,
    contactNumber: campaign.contactNumber,
    closingMethod: campaign.closingMethod,
    conversationCompletedMessage: campaign.conversationCompletedMessage,
    templateId: campaign.templateId,
    webChatTemplateId: campaign.webChatTemplateId,
    timeToAutoCloseConversationsInHours:
      campaign.timeToAutoCloseConversationsInHours,
    channel: campaign.channel,
    followUpMessage: campaign.followUpMessage,
    customTemplatedMessage: campaign.customTemplatedMessage,
    customTemplatedSubjectLine: campaign.customTemplatedSubjectLine,
    calendarMeetingTemplateId: campaign.calendarMeetingTemplateId
  });
};
